import React from 'react';
import { Page } from '../Page';
export function PageGutSide() {
  return <Page pageNumber={3} variant="light" data-id="element-1001">
      <div className="flex flex-col h-full" data-id="element-1002">
        <div className="mb-8 pt-4" data-id="element-1003">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1004">
            Understanding Your Medication
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1005">
            GLP-1 And <span className="text-tealslate" data-id="element-1006">The Gut</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate mb-4" data-id="element-1007" />
          <p className="text-sm text-[#3B3B3B] leading-[1.8] max-w-md" data-id="element-1008">
            The physical changes to your digestion that create lasting fullness.
          </p>
        </div>

        <p className="text-[10px] text-[#7A7A70] tracking-wider font-bold mb-1" data-id="element-1009">
          <em data-id="element-1010">Figure 1</em>
        </p>
        <div className="flex-1 -mx-12 px-12 flex flex-col justify-center" data-id="element-1011">
          <div className="flex justify-center" data-id="element-1012">
            <img src="https://cdn.magicpatterns.com/uploads/dysD2x9V1S39AoBcTvTWYN/Picture1.png" alt="Digestive system diagram showing how food stretches the stomach and activates stretch receptors" className="h-[637px] object-contain" data-id="element-1013" />
          </div>
        </div>

        <div className="pt-6" data-id="element-1014">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1015">
            <strong className="text-[#1F1F1F]" data-id="element-1016">How it works:</strong>{' '}
            <em data-id="element-1017">
              The medication slows the release of food from your stomach into
              the intestine. As food sits longer, stretch receptors fire and
              tell your brain you're full. The result: smaller portions feel
              like enough.
            </em>
          </p>
        </div>
      </div>
    </Page>;
}